import { render, staticRenderFns } from "./ReferralDetails.vue?vue&type=template&id=a542ceb0&scoped=true"
import script from "./ReferralDetails.vue?vue&type=script&lang=js"
export * from "./ReferralDetails.vue?vue&type=script&lang=js"
import style0 from "./ReferralDetails.vue?vue&type=style&index=0&id=a542ceb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a542ceb0",
  null
  
)

export default component.exports